import { defineMessages } from 'react-intl.macro';
// import description from './assets/description.json';

export default defineMessages({
  contactFormButton: {
    id: 'views.IssueOfShares.contactForm.send',
    defaultMessage: 'Wyślij'
  },
  contactFormWarning: {
    id: 'views.IssueOfShares.contactForm.warning',
    defaultMessage: 'Wszystkie zgody są wymagane!'
  },
  contactFormLoading: {
    id: 'views.IssueOfShares.contactForm.loading',
    defaultMessage: 'Wysyłanie...'
  },
  contactFormMessageSuccess: {
    id: 'views.IssueOfShares.contactForm.success',
    defaultMessage: 'Zgłoszenie zostało wysłane, dziękujemy!'
  },
  contactFormEmail: {
    id: 'views.IssueOfShares.contactForm.email',
    defaultMessage: 'Adres e-mail'
  },
  contactFormFirstName: {
    id: 'views.IssueOfShares.contactForm.firstName',
    defaultMessage: 'Imię'
  },
  contactFormLastName: {
    id: 'views.IssueOfShares.contactForm.lastName',
    defaultMessage: 'Nazwisko'
  },
  contactFormPhoneNumber: {
    id: 'views.IssueOfShares.contactForm.phoneNumber',
    defaultMessage: 'Numer telefonu'
  }
});



// WEBPACK FOOTER //
// ./src/views/IssueOfShares/IssueOfSharesView.intl.js